var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 16.667L9.99996 9.16699",
    stroke: "url(#paint0_linear_78_111)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9167 11.6663C9.28087 12.7188 10.1084 13.333 11.0417 13.333C12.7675 13.333 14.1667 12.038 14.1667 9.99968C14.1674 9.3912 14.0349 8.78995 13.7783 8.23818C13.5218 7.68642 13.1475 7.19754 12.6818 6.8059C12.2162 6.41426 11.6703 6.12937 11.0828 5.97126C10.4952 5.81314 9.88011 5.78564 9.28076 5.89068C8.68142 5.99572 8.11235 6.23075 7.61357 6.57926C7.11478 6.92777 6.69837 7.3813 6.39362 7.90796C6.08887 8.43463 5.90317 9.02165 5.84957 9.62776C5.79597 10.2339 5.87578 10.8444 6.08337 11.4163",
    stroke: "url(#paint1_linear_78_111)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
    stroke: "url(#paint2_linear_78_111)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_111",
    x1: 6.33891,
    y1: 5.24258,
    x2: 10.3435,
    y2: 5.25708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_111",
    x1: 5.01409,
    y1: 1.90116,
    x2: 15.025,
    y2: 1.99171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_111",
    x1: 1.02528,
    y1: -5.34883,
    x2: 19.0451,
    y2: -5.20203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF724D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D36E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.c59ea2b841d5380648ae875beecc01c3.svg";
export { ForwardRef as ReactComponent };